/**
 * useSupplierClaimsBadge [Phase 3]
 * Laedt Anzahl offener/ueberfaelliger Q2-Lieferantenreklamationen fuer Sidebar-Badge.
 * Auto-Refresh alle 60 Sekunden. Nur fuer User mit Q2-View-Permission sinnvoll.
 */
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { API } from '../lib/axiosClient';
import { AuthContext } from '../contexts/AuthContext';

const REFRESH_INTERVAL_MS = 60_000;

export function useSupplierClaimsBadge() {
  const { token, user } = useContext(AuthContext);
  const [counts, setCounts] = useState({ open: 0, overdue: 0 });

  useEffect(() => {
    if (!token) return undefined;
    if (!user?.permissions?.can_view_supplier_claims) return undefined;

    let alive = true;
    async function load() {
      try {
        const res = await axios.get(`${API}/supplier-claims/stats`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!alive) return;
        setCounts({
          open: res.data?.open || 0,
          overdue: res.data?.overdue || 0,
        });
      } catch {
        // Silently fail — Sidebar-Badge is non-critical
      }
    }
    load();
    const id = setInterval(load, REFRESH_INTERVAL_MS);
    return () => { alive = false; clearInterval(id); };
  }, [token, user?.permissions?.can_view_supplier_claims]);

  return counts;
}
